module.exports = __webpack_public_path__ + "root-b33b72b3/XING-Sans-Regular-23b3ddc3411d2aad68de58be373e8458.woff";